import SliderAssets from "./SliderAssets";

export default SliderAssets;